import __vue_component__$1 from '../Button/Button.vue.js';
import __vue_component__ from '../Popper/Popper.vue.js';
import pDebounce_1 from '../../node_modules/p-debounce/index.js';

//
var script = {
  name: 'MultiSelectRenderer',
  components: {
    Popper: __vue_component__,
    Button: __vue_component__$1
  },
  props: {
    selectedValues: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      isOpen: false,
      visibleCount: this.selectedValues.length
    };
  },

  computed: {
    visibleValues() {
      return this.selectedValues.slice(0, this.visibleCount);
    },

    hiddenValues() {
      return this.selectedValues.slice(this.visibleCount);
    }

  },

  created() {
    this.onResize = pDebounce_1(this.handleResize, 100);
    this.breakPoints = [];
  },

  mounted() {
    window.addEventListener('resize', this.onResize);
    this.checkOverflow();
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
  },

  updated() {
    this.checkOverflow();
  },

  methods: {
    handleResize() {
      this.checkOverflow();
    },

    checkOverflow() {
      const {
        overflowContainer
      } = this.$refs;
      const hasOverflow = overflowContainer.scrollWidth > overflowContainer.clientWidth;

      if (hasOverflow) {
        this.breakPoints[this.visibleCount] = overflowContainer.clientWidth;
        this.visibleCount -= 1;
      }

      while (overflowContainer.clientWidth > this.breakPoints[this.visibleCount + 1] && this.visibleCount < this.selectedValues.length) {
        this.visibleCount += 1;
      }
    },

    toggleDropdown() {
      this.isOpen = !this.isOpen;
    }

  }
};

export default script;



// WEBPACK FOOTER //
// ./node_modules/@spartez/vue-atlaskit/dist/components/field-renderers/MultiSelectRenderer.vue_rollup-plugin-vue=script.js